// extracted by mini-css-extract-plugin
module.exports = {"main":"Review_main_14kyA","mobile":"Review_mobile_1Osef","row":"Review_row_1_k9e","name":"Review_name_2KYW-","start":"Review_start_2e1A5","text":"Review_text_2AymU"};